import React from 'react';
const FooterComponent = props => {    
    return (
        <footer className="footer text-black ">
            {props.menus ? (
              <div className="content">
                    {props.menus.menus && props.menus.menus.map((menu, idx) =>
                        <div key={idx} className="footer-link" onClick={() => props.menuClicked(menu.value)}>
                            <a href={menu.url} className="mr-3 text-muted">{menu.value}  <span className='pull-right d-block d-lg-none d-md-none d-xl-none'><img src="/images/icon_right_gray.png" className="icon_right_gray" alt="right arrow"/></span></a> <div className={(props.menus.menus.length === (idx + 1)) ? "d-none" : "vbar"} ></div><div className="hbar"></div>
                        </div>
                    )}
                    <span className="text-muted copy-right">{props.menus.copyRight}</span>
                </div>

            ) : (
                    <div> <span className="text-muted copy-right">© Company. All rights Reserved.</span></div>
                )}
        </footer>
    )
}
export default FooterComponent;